const openEnded = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "open-ended",
    items: [
      { id: "q1", question: "El texto del mensaje 1", answers: [], image: null },
      { id: "q2", question: "El texto del mensaje 2", answers: [], image: null },
      { id: "q3", question: "El texto del mensaje 3", answers: [], image: null },
      { id: "q4", question: "El texto del mensaje 4", answers: [], image: null },
      { id: "q5", question: "El texto del mensaje 5", answers: [], image: null },
    ],
  },
  botId: "nualang.open-ended.0.0.1",
  botName: "open_ended",
  description: "open_ended_desc",
  difficulty: "ALL",
  learnLang: "spanish",
  name: "",
  botAvatar: "",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-comment-dots?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bienvenido
  
   
  Dile "hola" a bot para comenzar.`,
  voice: "",
  versionQuestion: "¿Cuántas preguntas le gustaría en esta plantilla?",
};

export default openEnded;
